
/**
 * 将Token设置为本地存储中
 * 该函数首先验证输入的token是否为非空字符串，然后尝试将token进行加密并存储在本地存储中
 * 如果输入的token无效或无法缓存，函数将记录相应的错误信息
 * @param {string} token - token不能为空
 */
export function setToken(token) {
  // 检查输入的令牌是否为非空字符串
  if (typeof token !== 'string' || token.trim() === '') {
    console.log('Invalid token: Expected a non-empty string');
    return;
  }
  try {
    // 将令牌加密并存储在本地存储中
    localStorage.setItem("accessToken", encryptToken(token)); // 假设有一个加密函数 encryptToken
  } catch (error) {
    // 如果设置令牌失败，记录错误信息
    console.log('Failed to set token:', error.message);
  }
}

/**
 * 将refreshToken设置为本地存储中
 *
 * 该函数首先验证输入的refreshToken是否为非空字符串，然后尝试将refreshToken进行加密并存储在本地存储中
 * 如果输入的refreshToken无效或无法缓存，函数将记录相应的错误信息
 *
 * @param {string} refreshToken - 需要存储的刷新令牌
 */
export function setRefreshToken(refreshToken) {
  // 检查refreshToken是否为非空字符串
  if (typeof refreshToken !== 'string' || refreshToken.trim() === '') {
    console.log('Invalid refresh token: Expected a non-empty string');
    return;
  }
  try {
    // 将加密后的刷新令牌存储到本地存储
    localStorage.setItem("refreshToken", encryptToken(refreshToken)); // 假设有一个加密函数 encryptToken
  } catch (error) {
    // 记录设置刷新令牌过程中遇到的错误
    console.log('Failed to set refresh token:', error.message);
  }
}

/**
 * 从本地存储中获取用户的访问token
 *
 * 本函数尝试从localStorage中获取加密过的accessToken，并将其解密后返回
 * 如果没有找到accessToken或者解密过程失败，函数将返回null
 *
 * @returns {string | null} 解密后的访问令牌字符串，如果没有找到或解密失败，则返回null
 */
export function getToken() {
  try {
    // 从localStorage获取加密的accessToken
    const encryptedToken = localStorage.getItem('accessToken');
    // 如果获取到加密的accessToken，则解密后返回；否则返回null
    return encryptedToken ? decryptToken(encryptedToken) : null; // 假设有一个解密函数 decryptToken
  } catch (error) {
    // 捕获异常，记录错误信息，并返回null
    console.log('Failed to get token:', error.message);
    return null;
  }
}

/**
 * 从本地存储中获取刷新refreshToken
 *
 * 本函数尝试从localStorage中获取加密的刷新令牌如果令牌存在，则使用decryptToken函数进行解密
 * 如果令牌不存在或解密过程中发生错误，函数将返回null
 *
 * @returns {string | null} 解密后的刷新令牌，如果获取或解密失败则返回null
 */
export function getRefreshToken() {
  try {
    // 从localStorage获取加密的刷新令牌
    const encryptedToken = localStorage.getItem('refreshToken');
    // 如果加密的令牌存在，则解密并返回令牌；否则返回null
    return encryptedToken ? decryptToken(encryptedToken) : null; // 假设有一个解密函数 decryptToken
  } catch (error) {
    // 捕获异常，并在控制台记录错误信息
    console.log('Failed to get refresh token:', error.message);
    // 在发生异常时返回null
    return null;
  }
}

/**
 * 移除本地存储中的accessToken
 *
 * 本函数从浏览器的本地存储中移除名为'accessToken'的项
 * 这通常用于用户退出或需要清除会话状态时
 * 该函数没有参数
 * 该函数没有返回值
 */
export function removeToken() {
  localStorage.removeItem('accessToken');
}

/**
 * 从本地存储中移除刷新refreshToken
 *
 * 本函数旨在清除存储在浏览器本地存储中的刷新令牌，以确保用户在登出或特定操作后，刷新令牌不会被保留
 * 这对于维护用户安全和隐私至关重要，确保没有旧的令牌可以被潜在的恶意第三方访问
 */
export function removeRefreshToken() {
  localStorage.removeItem('refreshToken');
}

// 假设的加密和解密函数（实际实现需要根据具体需求）
function encryptToken(token) {
  // 实现加密逻辑，例如使用 AES 加密
  return token ; // 示例中未实现加密，返回原值
  // return encryptData(token) ; // 示例中未实现加密，返回原值
}

function decryptToken(encryptedToken) {
  // 实现解密逻辑，例如使用 AES 解密
  return encryptedToken; // 示例中未实现解密，返回原值
  // return decryptData(encryptedToken); // 示例中未实现解密，返回原值
}
